import React from "react";
import Icone from "./Icone";

/**
 * Message d'état de la carte (avertissement, blocage, succès, information).
 * Les tons danger sont annoncés en alerte, les autres en statut.
 * `complement` est rendu sous le corps (ex. compte à rebours).
 */
const MessageEtat = ({ ton = "avert", icone = null, role, children, complement = null }) => (
  <div className={`etat ${ton}`} role={role || (ton === "danger" ? "alert" : "status")}>
    <div className="corps">
      {icone && <Icone nom={icone} />}
      <div>{children}</div>
    </div>
    {complement}
  </div>
);

export default MessageEtat;
